<template>
  <div v-if="isVisible" class="marquee-bar">
    <div ref="marqueeElement" class="marquee-bar__marquee marquee">
      <div class="marquee__inner">
        <span class="marquee__text">
          <slot />
        </span>
      </div>
    </div>

    <button class="marquee-bar__button-close" type="button" @click="close">
      <dpc-icon
        class="marquee-bar__icon-close"
        icon="close"
        label-path="close"
      ></dpc-icon>
    </button>
  </div>
</template>

<script setup>
import { Marquee } from '@3pc/marquee'; // Import the Marquee styles
import { ref, onMounted, onBeforeUnmount, shallowRef } from 'vue';

const marqueeElement = ref(null);
const marqueeAnimation = shallowRef(null);

onMounted(() => {
  marqueeAnimation.value = new Marquee(marqueeElement.value, {
    speed: 25,
    pauseOnHover: true,
  });

  marqueeAnimation.value.init();

  // const marqueeToggleButton = document.querySelector('.marquee-toggle');
  // marqueeToggleButton?.addEventListener('click', () =>
  //   marqueeAnimation.toggle()
  // );
});

onBeforeUnmount(() => {
  if (!marqueeAnimation.value) return;
  marqueeAnimation.value.destroy();
});

const isVisible = ref(true);

const close = () => {
  isVisible.value = false;
  if (!marqueeAnimation.value) return;
  marqueeAnimation.value.destroy();
};
</script>
